import Box from "@mui/material/Box";

import { actionLayerUpdate, actionLayerExpandLabelUpdated } from "./LayerRedux";
import { useDispatch, useSelector } from "react-redux";

import Grid from "@mui/material/Grid";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import Collapse from "@mui/material/Collapse";
import LabelSettings from "./LabelSettings";
import Typography from "@mui/material/Typography";
import Switch from "@mui/material/Switch";

const SWITCH_LABELS_ARRAY = [
  "facultyallocationlabs",
  "facultyallocationoffices",
  "facultyallocationothers",
  "roomnumbernonassignable",
];

export default function LabelTabPanel({ layers }) {
  return (
    <Grid container>
      <LabelSettings />
      {layers
        .filter((layer) => layer.type === "label" && !layer.hasParent)
        .map((layer) => {
          if (layer.isParent) {
            return <LabelParent layer={layer} key={layer.id} layers={layers} />;
          } else {
            return <Label layer={layer} key={layer.id} />;
          }
        })}
    </Grid>
  );
}

const label_ = (theme) => ({
  paddingLeft: "5px",
  "& .MuiCheckbox-root": {
    padding: "0px",
    marginRight: "4px",
  },
  "& .MuiTypography-overline": {
    lineHeight: 1,
  },
});

const expand_ = (theme) => ({
  position: "relative",
  right: 12,
  top: 3,
  "&:hover": {
    cursor: "pointer",
  },
});

const children_ = (theme) => ({
  paddingLeft: "22px",
});

function Label({ layer }) {
  const { id, label } = layer;
  let checked = useSelector((state) => state.layerReducer.label[id]);
  const indeterminate = checked === "indeterminate";
  checked = checked === "indeterminate" || checked;
  const dispatch = useDispatch();

  const onChange = (event) => {
    const isVisible = event.target.checked;
    const data = { id, isVisible };
    dispatch(actionLayerUpdate({ type: "label", data }));
  };

  const onClick = () => {
    dispatch(actionLayerExpandLabelUpdated(layer.id));
  };

  return (
    <Grid container size={{ xs: 12 }} sx={label_}>
      <FormControlLabel
        value="show"
        control={
          SWITCH_LABELS_ARRAY.includes(id) ? (
            <Switch
              color="primary"
              checked={checked}
              onChange={onChange}
              size="small"
            />
          ) : (
            <Checkbox
              color="primary"
              checked={checked}
              onChange={onChange}
              indeterminate={indeterminate}
            />
          )
        }
        label={
          <Typography
            variant="overline"
            data-testid={`layer-label-type-${layer.id}`}
          >
            {label}
          </Typography>
        }
      />
      {layer.isParent && (
        <KeyboardArrowDownIcon onClick={onClick} sx={expand_} />
      )}
    </Grid>
  );
}

function LabelParent({ layer, layers }) {
  const expand = useSelector(
    (state) => state.layerReducer.expandLabel[layer.id],
  );
  const childLayers = layers.filter((l) => layer.children.indexOf(l.id) !== -1);

  return (
    <>
      <Label layer={layer} key={layer.id} />
      <Box sx={children_}>
        <Collapse in={expand}>
          {childLayers.length &&
            childLayers.map((childLayer) => (
              <Label layer={childLayer} key={childLayer.id} />
            ))}
        </Collapse>
      </Box>
    </>
  );
}
